import {
  FETCH,
  DONE,
  FAIL,
  GET,
  PRINT,
  MODULE,
  EDIT,
  DATA,
  RESET,
  SET,
  STUDY,
  MEDICAL,
  GROUPS,
  REMARK,
  TOTAL_UVR,
  DISCIPLINES,
  JOURNAL,
  PARAMS, SUBJECTS, LIST, FILTER,
  APPEALS,
  ALL,
  BY,
  STUDENT,
  ONE,
  POST,
  DELETE,
  RESULT,
  TEACHERS,
} from "../../constants";

import reducerStatuses from "../../status";
import { createReducer, PayloadAction } from "@reduxjs/toolkit";
import { TFetch } from "../../types";

const initialState: TFetch = {
  groups: {
    ...reducerStatuses,
    data: null as any,
  },
  modules: {
    ...reducerStatuses,
    data: [] as any,
  },
  study: {
    ...reducerStatuses,
    data: [] as any,
  },
  medical: {
    ...reducerStatuses,
    data: [] as any,
  },
  medicalEdit: {
    ...reducerStatuses,
    data: [] as any,
  },
  medicalGroups: {
    ...reducerStatuses,
    data: [] as any,
  },
  remark: {
    ...reducerStatuses,
    data: [] as any,
  },
  totalUvr: {
    ...reducerStatuses,
    data: [] as any,
  },
  totalUvrDisciplines: {
    ...reducerStatuses,
    data: [] as any,
  },
  printJournalParams: {
    ...reducerStatuses,
    data: [] as any,
  },
  printJournalSubjectList: {
    ...reducerStatuses,
    data: [] as any,
  },
  printJournal: {
    ...reducerStatuses,
    data: [] as any,
  },
  appeals: {
    ...reducerStatuses,
    data: [] as any,
  },
  studentByGroup: {
    ...reducerStatuses,
    data: [] as any,
  },
  appealsOne: {
    ...reducerStatuses,
    data: [] as any,
  },
  postAppeals: {
    ...reducerStatuses,
    data: [] as any,
  },
  editAppeals: {
    ...reducerStatuses,
    data: [] as any,
  },
  deleteAppeals:{
    ...reducerStatuses,
    data: [] as any,
  },
  deleteMedicalResult:{
    ...reducerStatuses,
    data: [] as any,
  },
  teachersList:{
    ...reducerStatuses,
    data: [] as any,
  },
  deletedRemark:{
    ...reducerStatuses,
    data: [] as any,
  },
};

export default createReducer(initialState, builder =>
  builder
    .addCase(PRINT + DATA + RESET, (state) => ({
      ...initialState
    }))


    .addCase(GET + PRINT + MODULE + FETCH, (state) => ({
      ...state,
      modules: {
        ...initialState.modules,
        loading: true
      }
    }))
    .addCase(GET + PRINT + MODULE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      modules: {
        ...initialState.modules,
        success: true,
        data: payload.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(GET + PRINT + MODULE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      modules: {
        ...initialState.modules,
        failed: true
      }
    }))

    .addCase(PRINT + MODULE + SET + EDIT + FETCH, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      [payload.reduxState]: {
        ...initialState[payload.reduxState],
        data: state[payload.reduxState]?.data?.map((item: any, index: any) => {
          if (index === payload.index) {
            return {
              ...item,
              ...payload.object
            }
          } else {
            return item
          }
        }),
      }
    }))

    .addCase(PRINT + MODULE + RESET + EDIT + FETCH, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      [payload.reduxState]: {
        ...initialState[payload.reduxState],
        data: state[payload.reduxState]?.data?.map((item: any, index: any) => ({ ...item, isEdit: false })),
      }
    }))


    .addCase(PRINT + MODULE + EDIT + FETCH, (state) => ({
      ...state,
      modules: {
        ...initialState.modules,
        loading: true,
        data: state.modules.data
      }
    }))
    .addCase(PRINT + MODULE + EDIT + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      modules: {
        ...initialState.modules,
        success: true,
        data: state.modules.data.map((item: any) => {
          if (item.id === payload.id) {
            return {
              ...item,
              isEdit: false,
              date_start: payload.date_start,
              date_end: payload.date_end,
            }
          } else {
            return item
          }
        })
      }
    }))
    .addCase(PRINT + MODULE + EDIT + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      modules: {
        ...state.modules,
        failed: true,
        loading: false,
        data: state.modules.data.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))


    .addCase(GET + PRINT + STUDY + FETCH, (state) => ({
      ...state,
      study: {
        ...initialState.study,
        loading: true
      }
    }))
    .addCase(GET + PRINT + STUDY + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      study: {
        ...initialState.study,
        success: true,
        data: payload.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(GET + PRINT + STUDY + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      study: {
        ...initialState.study,
        failed: true
      }
    }))

    .addCase(EDIT + PRINT + STUDY + FETCH, (state) => ({
      ...state,
      study: {
        ...initialState.study,
        loading: true,
        data: state.study.data
      }
    }))
    .addCase(EDIT + PRINT + STUDY + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      study: {
        ...initialState.study,
        success: true,
        data: state.study.data.map((item: any) => {
          if (item.person_id === payload.person_id) {
            return {
              ...item,
              isEdit: false,
              ...(payload.birth_date ? { birth_date: payload.birth_date } : {}),
              ...(payload.name_book ? { name_book: payload.name_book } : {}),
              ...(payload.order_date ? { order_date: payload.order_date } : {}),

              ...(payload.contacts ? { contacts: payload.contacts } : {}),
              ...(payload.additional_info ? { additional_info: payload.additional_info } : {}),
              ...(payload.contingent_movement ? { contingent_movement: payload.contingent_movement } : {}),
            }
          } else {
            return item
          }
        })
      }
    }))
    .addCase(EDIT + PRINT + STUDY + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      study: {
        ...state.study,
        failed: true,
        loading: false,
        data: state.study.data.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))

    .addCase(GET + PRINT + MEDICAL + GROUPS + FETCH, (state) => ({
      ...state,
      medicalGroups: {
        ...initialState.medicalGroups,
        loading: true
      }
    }))
    .addCase(GET + PRINT + MEDICAL + GROUPS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medicalGroups: {
        ...initialState.medicalGroups,
        success: true,
        data: payload.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(GET + PRINT + MEDICAL + GROUPS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medicalGroups: {
        ...initialState.medicalGroups,
        failed: true
      }
    }))


    .addCase(GET + PRINT + MEDICAL + FETCH, (state) => ({
      ...state,
      medical: {
        ...initialState.medical,
        loading: true
      }
    }))
    .addCase(GET + PRINT + MEDICAL + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medical: {
        ...initialState.medical,
        success: true,
        data: payload.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(GET + PRINT + MEDICAL + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medical: {
        ...initialState.medical,
        failed: true
      }
    }))

    .addCase(PRINT + MEDICAL + EDIT + FETCH, (state) => ({
      ...state,
      medicalEdit: {
        ...initialState.medicalEdit,
        loading: true,
      }
    }))
    .addCase(PRINT + MEDICAL + EDIT + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medicalEdit: {
        ...initialState.medicalEdit,
        success: true,
        data: payload
      }
    }))
    .addCase(PRINT + MEDICAL + EDIT + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medicalEdit: {
        ...initialState.medicalEdit,
        failed: true,
      }
    }))
    .addCase(PRINT + MEDICAL + EDIT + FETCH + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      medicalEdit: {
        ...initialState.medicalEdit,
      }
    }))
    .addCase(GET + PRINT + REMARK + FETCH, (state) => ({
      ...state,
      remark: {
        ...initialState.remark,
        loading: true
      }
    }))
    .addCase(GET + PRINT + REMARK + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      remark: {
        ...initialState.remark,
        success: true,
        data: payload.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(GET + PRINT + REMARK + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      remark: {
        ...initialState.remark,
        failed: true
      }
    }))

    .addCase(SET + PRINT + REMARK + FETCH, (state) => ({
      ...state,
      remark: {
        ...initialState.remark,
        loading: true,
        data: state.remark.data.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(SET + PRINT + REMARK + FETCH + FAIL, (state) => ({
      ...state,
      remark: {
        ...state.remark,
        loading: false,
        failed: true,
        data: state.remark.data.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))


    .addCase(GET + PRINT + TOTAL_UVR + FETCH, (state) => ({
      ...state,
      totalUvr: {
        ...initialState.totalUvr,
        loading: true
      }
    }))
    .addCase(GET + PRINT + TOTAL_UVR + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      totalUvr: {
        ...initialState.totalUvr,
        success: true,
        data: payload.map((item: any) => ({ ...item, isEdit: false }))
      }
    }))
    .addCase(GET + PRINT + TOTAL_UVR + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      totalUvr: {
        ...initialState.totalUvr,
        failed: true
      }
    }))

    .addCase(GET + DISCIPLINES + PRINT + TOTAL_UVR + FETCH, (state) => ({
      ...state,
      totalUvrDisciplines: {
        ...initialState.totalUvrDisciplines,
        loading: true
      }
    }))
    .addCase(GET + DISCIPLINES + PRINT + TOTAL_UVR + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      totalUvrDisciplines: {
        ...initialState.totalUvrDisciplines,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + DISCIPLINES + PRINT + TOTAL_UVR + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      totalUvrDisciplines: {
        ...initialState.totalUvrDisciplines,
        failed: true
      }
    }))

    .addCase(PRINT + JOURNAL + FETCH, (state) => ({
      ...state,
      printJournal: {
        ...initialState.printJournal,
        loading: true
      }
    }))
    .addCase(PRINT + JOURNAL + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      printJournal: {
        ...initialState.printJournal,
        success: true,
        data: payload
      }
    }))
    .addCase(PRINT + JOURNAL + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      printJournal: {
        ...initialState.printJournal,
        failed: true
      }
    }))


    .addCase(EDIT + PRINT + REMARK + FETCH, (state) => ({
      ...state,
      remark: {
        ...state.remark,
        loading: true
      }
    }))
    .addCase(EDIT + PRINT + REMARK + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      remark: {
        ...initialState.remark,
        success: true,
        data: state.remark.data.map((item: any) => {
          if (item.remark_id === payload.remark_id) {
            return payload
          } else {
            return item
          }
        })
      }
    }))
    .addCase(EDIT + PRINT + REMARK + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      remark: {
        ...initialState.remark,
        failed: true
      }
    }))


    .addCase(PRINT + JOURNAL + PARAMS + FETCH, (state) => ({
      ...state,
      printJournalParams: {
        ...initialState.printJournalParams,
        loading: true
      }
    }))
    .addCase(PRINT + JOURNAL + PARAMS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      printJournalParams: {
        ...initialState.printJournalParams,
        success: true,
        data: payload
      }
    }))
    .addCase(PRINT + JOURNAL + PARAMS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      printJournalParams: {
        ...initialState.printJournalParams,
        failed: true
      }
    }))


    .addCase(PRINT + JOURNAL + SUBJECTS + LIST + FETCH, (state) => ({
      ...state,
      printJournalSubjectList: {
        ...initialState.printJournalSubjectList,
        loading: true
      }
    }))
    .addCase(PRINT + JOURNAL + SUBJECTS + LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      printJournalSubjectList: {
        ...initialState.printJournalSubjectList,
        success: true,
        data: payload
      }
    }))
    .addCase(PRINT + JOURNAL + SUBJECTS + LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      printJournalSubjectList: {
        ...initialState.printJournalSubjectList,
        failed: true
      }
    }))

    .addCase(GET + FILTER + GROUPS + FETCH, (state) => ({
      ...state,
      groups: {
        ...initialState.groups,
        loading: true
      }
    }))
    .addCase(GET + FILTER + GROUPS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      groups: {
        ...initialState.groups,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + FILTER + GROUPS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      groups: {
        ...initialState.groups,
        failed: true
      }
    }))
    .addCase(GET + FILTER + APPEALS + FETCH, (state) => ({
      ...state,
      appeals: {
        ...initialState.appeals,
        loading: true
      }
    }))
    .addCase(GET + FILTER + APPEALS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      appeals: {
        ...initialState.appeals,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + FILTER + APPEALS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      appeals: {
        ...initialState.appeals,
        failed: true
      }
    }))



    .addCase(GET + STUDENT + BY + FETCH, (state) => ({
      ...state,
      studentByGroup: {
        ...initialState.studentByGroup,
        loading: true
      }
    }))
    .addCase(GET + STUDENT + BY + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      studentByGroup: {
        ...initialState.studentByGroup,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + STUDENT + BY + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      studentByGroup: {
        ...initialState.studentByGroup,
        failed: true
      }
    }))


    .addCase(GET + APPEALS + ONE + FETCH, (state) => ({
      ...state,
      appealsOne: {
        ...initialState.appealsOne,
        loading: true
      }
    }))
    .addCase(GET + APPEALS + ONE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      appealsOne: {
        ...initialState.appealsOne,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + APPEALS + ONE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      appealsOne: {
        ...initialState.appealsOne,
        failed: true
      }
    }))


    .addCase(POST + APPEALS, (state) => ({
      ...state,
      postAppeals: {
        ...initialState.postAppeals,
        loading: true
      }
    }))
    .addCase(POST + APPEALS + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postAppeals: {
        ...initialState.postAppeals,
        success: true,
        data: payload
      }
    }))
    .addCase(POST + APPEALS + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postAppeals: {
        ...initialState.postAppeals,
        failed: true
      }
    }))
    .addCase(POST + APPEALS + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      postAppeals: {
        ...initialState.postAppeals,
        data: []
      }
    }))


    .addCase(EDIT + APPEALS, (state) => ({
      ...state,
      editAppeals: {
        ...initialState.editAppeals,
        loading: true
      }
    }))
    .addCase(EDIT + APPEALS + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editAppeals: {
        ...initialState.editAppeals,
        success: true,
        data: payload
      }
    }))
    .addCase(EDIT + APPEALS + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editAppeals: {
        ...initialState.editAppeals,
        failed: true
      }
    }))
    .addCase(EDIT + APPEALS + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      editAppeals: {
        ...initialState.editAppeals,
        data: []
      }
    }))
    
    .addCase(DELETE + APPEALS, (state) => ({
      ...state,
      deleteAppeals: {
        ...initialState.deleteAppeals,
        loading: true
      }
    }))
    .addCase(DELETE + APPEALS + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteAppeals: {
        ...initialState.deleteAppeals,
        success: true,
        data: payload
      }
    }))
    .addCase(DELETE + APPEALS + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteAppeals: {
        ...initialState.deleteAppeals,
        failed: true
      }
    }))
    .addCase(DELETE + APPEALS + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteAppeals: {
        ...initialState.deleteAppeals,
      }
    }))
        
    .addCase(DELETE + MEDICAL + RESULT + FETCH, (state) => ({
      ...state,
      deleteMedicalResult: {
        ...initialState.deleteMedicalResult,
        loading: true
      }
    }))
    .addCase(DELETE + MEDICAL + RESULT + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteMedicalResult: {
        ...initialState.deleteMedicalResult,
        success: true,
        data: payload
      }
    }))
    .addCase(DELETE + MEDICAL + RESULT + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteMedicalResult: {
        ...initialState.deleteMedicalResult,
        failed: true
      }
    }))
    .addCase(DELETE + MEDICAL + RESULT + FETCH + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteMedicalResult: {
        ...initialState.deleteMedicalResult,
      }
    }))

    .addCase(GET + TEACHERS + FETCH, (state) => ({
      ...state,
      teachersList: {
        ...initialState.teachersList,
        loading: true
      }
    }))
    .addCase(GET + TEACHERS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      teachersList: {
        ...initialState.teachersList,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + TEACHERS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      teachersList: {
        ...initialState.teachersList,
        failed: true
      }
    }))


    .addCase(DELETE + PRINT + REMARK + FETCH, (state) => ({
      ...state,
      deletedRemark: {
        ...initialState.deletedRemark,
        loading: true
      }
    }))
    .addCase(DELETE + PRINT + REMARK + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletedRemark: {
        ...initialState.deletedRemark,
        success: true,
        data: payload
      }
    }))
    .addCase(DELETE + PRINT + REMARK + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletedRemark: {
        ...initialState.deletedRemark,
        failed: true
      }
    }))
    .addCase(DELETE + PRINT + REMARK + FETCH + RESET, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deletedRemark: {
        ...initialState.deletedRemark,
      }
    }))
)
